export default __webpack_public_path__ + "static/media/14.78c0c354.png";